import { render, staticRenderFns } from "./AuthLogoutView.vue?vue&type=template&id=bcb94764&scoped=true"
import script from "./AuthLogoutView.vue?vue&type=script&lang=ts"
export * from "./AuthLogoutView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb94764",
  null
  
)

export default component.exports